import { render, staticRenderFns } from "./areaMainOpportunitySelect.vue?vue&type=template&id=2de38b3b&scoped=true&"
import script from "./areaMainOpportunitySelect.vue?vue&type=script&lang=js&"
export * from "./areaMainOpportunitySelect.vue?vue&type=script&lang=js&"
import style0 from "./areaMainOpportunitySelect.vue?vue&type=style&index=0&id=2de38b3b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de38b3b",
  null
  
)

export default component.exports